import { MediaTypeEnum } from "src/app/shared/enum/media-type.enum";

export class DisplayableMediaStruct {
    public sourceUrl: string = '';
    public order: number | null = null;
    public mediaType: MediaTypeEnum | null = null;
    public screenSeconds: number | null = null;
}

